import React from "react";
import Checkbox from "components/form/checkbox/Checkbox";
import "./accounts.scss";

export type BatchOptionItem = {
  key: string;
  title: string;
  description?: string;
  selected: boolean;
  onSelect: () => void;
  /** Extra content shown under the option when selected (e.g. amount, date/time). */
  content?: React.ReactNode;
};

type Props = {
  "aria-label"?: string;
  role?: "radiogroup" | "group";
  options: BatchOptionItem[];
};

export default function BatchOptionGroup(props: Props) {
  const { options, role = "group", "aria-label": ariaLabel } = props;

  return (
    <div className="batch-option-group" role={role} aria-label={ariaLabel}>
      {options.map((option, index) => (
        <div
          key={option.key}
          className={`batch-option-group__row${
            index < options.length - 1 ? " batch-option-group__row--divided" : ""
          }`}
        >
          <button
            type="button"
            className="batch-option-group__option"
            onClick={option.onSelect}
            aria-pressed={option.selected}
          >
            <span className="batch-option-group__checkbox" aria-hidden="true">
              <Checkbox size="medium" checked={option.selected} readOnly tabIndex={-1} />
            </span>
            <span className="batch-option-group__copy">
              <span className="batch-option-group__title">{option.title}</span>
              {option.description ? (
                <span className="batch-option-group__description">{option.description}</span>
              ) : null}
            </span>
          </button>
          {option.selected && option.content ? (
            <div
              className="batch-option-group__content"
              onClick={event => event.stopPropagation()}
            >
              {option.content}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
